import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@services/language.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-select-language',
    templateUrl: './select-language.component.html',
    styleUrls: ['./select-language.component.scss'],
    standalone: false
})
export class SelectLanguageComponent implements OnInit {
  public languages: any[];
  public showDropdown = false;
  public languageSelected = '';
  // Open dropdown: the current language first (as the header), then the others
  public dropdownLanguages: any[] = [];

  constructor(
    private readonly languageService: LanguageService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef
    ) {
    this.languages = [
      {label: 'Português', value: 'pt_PT'},
      {label: 'Español', value: 'es_ES'},
      {label: 'English', value: 'en_EN'}      
    ];

    this.setLanguageSelected(this.languageService.getLanguage());
  }

  ngOnInit(): void {
    this.languageService.languageChange().subscribe(
      (lang: string) => {
        this.setLanguageSelected(lang);
        this.cdr.detectChanges();
      }
    );
  }

  private setLanguageSelected(languageKey: string): void {
    this.languageSelected = this.languages.find(lang => lang.value === languageKey)?.label || '';
    this.dropdownLanguages = [
      ...this.languages.filter(lang => lang.value === languageKey),
      ...this.languages.filter(lang => lang.value !== languageKey)
    ];
  }

  public onSelect(language: any): void {
    this.languageService.updateCurrentLanguage(language.value);
    this.showDropdown = false;
    this.cdr.detectChanges();
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
    this.cdr.detectChanges();
  }
}
